import React from 'react';
import { Label } from '../Label';
export const Radio = ({ label, selected, tooltip, onSelect }) => {
    return (React.createElement("div", { "data-testid": "radio", className: "flex flex-row gap-2 items-center" },
        React.createElement("div", { className: "flex flex-row gap-2 items-center cursor-pointer", onClick: () => onSelect() },
            React.createElement("input", { type: "radio", checked: selected }),
            label && React.createElement(Label, { tooltip: tooltip }, label))));
};
export * from './index.types';
//# sourceMappingURL=index.js.map